import { useQuery, useQueryClient } from 'react-query';

import { invitationsApi } from 'src/Services/API';

const useValidateInvitation = (token?: string) => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ['validate-invitation', token],
    queryFn: async () => {
      const response = await invitationsApi.invitationsControllerValidate(token ?? '');
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    enabled: token !== undefined,
    retry: false,
    onSuccess: () => {
      queryClient.invalidateQueries('fetch-assets');
    },
  });
};

export default useValidateInvitation;
